import { Image, Text, View, Textarea, Input } from 'components';
import Base, { Config } from 'components/sixshot/Base';
import React from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import styles from './index.module.scss';


interface State {
  content?: string
  phone?: string
}
/**
 * 
 * **/
export default class AdviceApply extends Base<any, State> {
  public config: Config = {
    navigationBarTitleText: '提交申请'
  };

  public state: State = {
    content: '',
    phone: ''
  };

  public async didMount() {
    // await this.getUserInfo();

    // const params:any = this.navigator.getParams(' '+this.props.location.search) || {}
    // const col = this.props.location.state.column
    
  }

  public render() {
    const { content, phone } = this.state;

    return (
      <View className={styles.container}>
        <ToastContainer className={styles.ToastContainer}/>

        <View className={styles.sec}>
          <View className={styles.title}>请填写申请：</View>
          <View className={styles.taInner}>
            <Textarea 
              className={styles.ta}
              value={content}
              placeholder='请说明你的需求，客服人员会尽快联系你'
              name="content"
              valueChange={this.textareaChange}
            />
          </View>
        </View>

        <View className={styles.sec}>
          <View className={styles.title}>你的手机号：</View>
          <View className={styles.taInner}>
            <View className={styles.inputBox}>
              <View className={styles.before}>+86</View>
              <Input
                value={phone}
                name="phone"
                type="number"
                className={styles.input}
                placeholder="请输入手机号"
                valueChange={this.textareaChange}
              />
            </View>
          </View>
        </View>

        <View className={styles.btn} onClick={this.handleSubmit}>点此提交</View>
        
      </View>
    );
  }

  private textareaChange = (name,e) => {
    // console.log("aa",name,e.target.value)
    this.setState({[name]:  e.target.value})
    // console.log(parse(e.target.value))
  }

  private handleBack = () => {
    if(this.interface.uaEnv.isWechatMp()){
      window.wx.miniProgram.navigateBack()
    }else if(this.interface.uaEnv.isReactNative) {
      this.interface.postMessage('back')
    }else {
      this.navigator.back()
    }
  }


  private handleSubmit = async() => {
    const { phone, content } = this.state
    if(!content || content.length < 2) {
      toast.error("请输入需求内容",{
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1500,
        closeButton: false,
      })
      return false;
    }
    if(!/^1\d{10}$/.test(phone || '')) {
      toast.error("请填写正确手机号",{
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1500,
        closeButton: false,
      })
      return false;
    }
    const { status, msg } = await this.apiClient.base.advice({
      phone,
      content,
      type: 2  //1：普通意见，2：代理申请，默认1	
    })

    if(status !== 10000){
      toast.error(msg, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1500,
        closeButton: false,
      })
      return;
    }

    toast.success("提交成功！", {
      position: toast.POSITION.TOP_RIGHT,
      autoClose: 1500,
      closeButton: false,
    })
    setTimeout(() => {
      this.handleBack()
    }, 1500)
    

  }

  
}

